// client/src/api/paymentApi.js

import axios from "axios";

// =====================================
// INVOICE PROCESSING (EXISTING)
// =====================================
export async function processInvoices(files, onProgress = () => {}) {

  const formData = new FormData();

  files.forEach((file) => {
    formData.append("pdfs", file);
  });

  const response = await axios.post("/api/invoices/process", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (event) => {
      if (!event.total) return;
      const percent = Math.round((event.loaded * 100) / event.total);
      onProgress(percent);
    },
  });

  return response.data;
}

// =====================================
// PAYMENT STATS
// =====================================
export const getPaymentStats = async () => {
  const response = await fetch("/api/payments/stats");
  if (!response.ok) throw new Error("Failed to fetch payment stats");
  return response.json();
};

// =====================================
// GET INVOICES
// =====================================
export const getInvoices = async () => {
  const response = await fetch("/api/payments/invoices");
  if (!response.ok) throw new Error("Failed to fetch invoices");
  return response.json();
};

// =====================================
// UPLOAD PAYMENTS
// =====================================
export const uploadPayments = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch("/api/payments/upload", {
    method: "POST",
    body: formData,
  });
  if (!response.ok) throw new Error("Failed to upload payments");
  return response.json();
};

// =====================================
// UPDATE INVOICE
// =====================================
export const updateInvoice = async (id, data) => {
  const response = await fetch(`/api/payments/update/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error("Failed to update invoice");
  return response.json();
};

// =====================================
// SEARCH INVOICES
// =====================================
export const searchInvoices = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.invoice_number) params.append("invoice_number", filters.invoice_number);
  if (filters.vendor) params.append("vendor", filters.vendor);
  if (filters.billing_quarter) params.append("billing_quarter", filters.billing_quarter);
  if (filters.payment_status) params.append("payment_status", filters.payment_status);
  const response = await fetch(`/api/payments/search?${params.toString()}`);
  if (!response.ok) throw new Error("Search failed");
  return response.json();
};

// =====================================
// GET QUARTERS
// =====================================
export const getQuarters = async () => {
  const response = await fetch("/api/payments/quarters");
  if (!response.ok) throw new Error("Failed to fetch quarters");
  return response.json();
};